import React from "react";

/**
 * Reusable Button Component
 * Supports variants and loading state
 */

const variants = {
  primary: "bg-blue-600 hover:bg-blue-700 text-white",
  danger: "bg-red-600 hover:bg-red-700 text-white",
  success: "bg-green-600 hover:bg-green-700 text-white",
  secondary: "bg-gray-200 hover:bg-gray-300 text-gray-800",
};

const Button = ({
  children,
  variant = "primary",
  onClick,
  loading = false,
  disabled = false,
  className = "",
  type = "button",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        px-4 py-2 rounded-lg text-sm font-medium transition
        ${variants[variant]}
        ${(disabled || loading) ? "opacity-50 cursor-not-allowed" : ""}
        ${className}
      `}
    >
      {loading ? "Processing..." : children}
    </button>
  );
};

export default Button;